module.exports = __webpack_public_path__ + "img/Harris-Case-Study-600px.0c1855bb.png";